/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var Footer;

(function (Footer) {
  Footer["DEFAULT"] = "default";
  Footer["CUSTOM"] = "custom";
})(Footer || (Footer = {}));